import { createStore } from '../_core/createStore';
import { navigationPaneStore } from './navigationPaneStore';

const useNavigationPaneStore = createStore({
  creator: navigationPaneStore,
  id: 'navigationPane',
  middlewares: {
    devtools: true,
  },
});

export default useNavigationPaneStore;
